module.exports = __webpack_public_path__ + "h5/img/2.4b12e615.png";